import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaTrash } from "react-icons/fa";

export default function Guests() {
  const navigate = useNavigate();

  const guestsData = [
    { id: 1, name: "Arun Kumar", phone: "9876543210", room: "101", type: "Deluxe", checkIn: "2026-02-01", checkOut: "2026-02-03", status: "Checked In" },
    { id: 2, name: "Suresh R", phone: "9123456780", room: "102", type: "Standard", checkIn: "2026-02-01", checkOut: "2026-02-02", status: "Checked Out" },
    { id: 3, name: "Priya M", phone: "9001234567", room: "103", type: "Deluxe", checkIn: "2026-02-02", checkOut: "2026-02-04", status: "Checked In" },
    { id: 4, name: "Rahul S", phone: "9898989898", room: "104", type: "Suite", checkIn: "2026-02-02", checkOut: "2026-02-05", status: "Checked In" },
    { id: 5, name: "Divya K", phone: "9784561230", room: "105", type: "Standard", checkIn: "2026-02-03", checkOut: "2026-02-04", status: "Booked" },
    { id: 6, name: "Vijay A", phone: "9654321876", room: "106", type: "Deluxe", checkIn: "2026-02-03", checkOut: "2026-02-06", status: "Checked In" },
    { id: 7, name: "Karthik P", phone: "9345678123", room: "107", type: "Suite", checkIn: "2026-02-04", checkOut: "2026-02-06", status: "Booked" },
    { id: 8, name: "Meena L", phone: "9871203456", room: "108", type: "Standard", checkIn: "2026-02-04", checkOut: "2026-02-05", status: "Checked Out" },
    { id: 9, name: "Ajith R", phone: "9998887776", room: "109", type: "Deluxe", checkIn: "2026-02-05", checkOut: "2026-02-07", status: "Checked In" },
    { id: 10, name: "Anitha S", phone: "9012345678", room: "110", type: "Standard", checkIn: "2026-02-05", checkOut: "2026-02-06", status: "Booked" },
    { id: 11, name: "Manoj T", phone: "9887766554", room: "111", type: "Deluxe", checkIn: "2026-02-06", checkOut: "2026-02-08", status: "Checked In" },
  ];

  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(guestsData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentGuests = guestsData.slice(startIndex, startIndex + itemsPerPage);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (

    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive" onClick={() => navigate("/admin/guests")}> Guests</span>
        </div>

        {/* Right: Button */}
        <Button
          className="add-outlet-btn"
          onClick={() => navigate(-1)}
        >
           ← Back
        </Button>
      </div>

      <Container fluid>
        {/* Page */}
        <div className="guests-page mt-4">
          <h5 className="guests-title mb-3" style={{ color: "#2A8F9E" }}>
            Guests Management
          </h5>

          {/* Table */}
          <div className="table-responsive common-table-wrapper common-table-wrapper">
            <table className="table align-middle common-table guests-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Guest Name</th>
                  <th>Phone</th>
                  <th>Room No</th>
                  <th>Room Type</th>
                  <th>Check-In</th>
                  <th>Check-Out</th>
                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {currentGuests.map((guest, index) => (
                  <tr key={guest.id}>
                    <td>{startIndex + index + 1}</td>
                    <td className="guest-name">{guest.name}</td>
                    <td>{guest.phone}</td>
                    <td>{guest.room}</td>
                    <td>{guest.type}</td>
                    <td>{guest.checkIn}</td>
                    <td>{guest.checkOut}</td>
                    <td>
                      <span
                        className={`guest-status ${guest.status
                          .toLowerCase()
                          .replace(" ", "-")}`}
                      >
                        {guest.status}
                      </span>
                    </td>
                    <td className="text-center align-middle">
                      <button className="btn btn-sm guest-btn-view me-2" style={{ border: "none" }}>
                        <FaEye size={16} style={{ color: "blue" }} />
                      </button>

                      <button className="btn btn-sm guest-btn-remove" style={{ border: "none" }}>
                        <FaTrash size={16} style={{ color: "red" }} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-end mt-3 guests-pagination">
            <button
              className="btn btn-sm guest-page-btn me-2"
              onClick={() => changePage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`btn btn-sm guest-page-btn me-2 ${currentPage === i + 1 ? "active" : ""
                  }`}
                onClick={() => changePage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-sm guest-page-btn"
              onClick={() => changePage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </Container>
    </>
  );
}
